/* GASSISA
=========================================================================================
* Descripción: Acciones del módulo de Cuentas X Cobrar.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1        | 24/10/2026 | Lic. José Luis Aragón Cervantes  | Menú estándar para crédito a clientes
* ---------------------------------------------------------------------------------------
*/

import { Fragment } from "react";
import { IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";

const ActionTooltip = ({ title, children }) => (
    <Tooltip title={title}>
        <span style={{ display: "inline-flex" }}>{children}</span>
    </Tooltip>
);

export default function MnuCuentasXcobrarActions({
    onSalir,
    onBuscarCliente,
    onNuevoAbono,
    onVistaPreviaEstado,
    disabledNuevoAbono,
    disabledVistaPrevia,
}) {
    return (
        <Fragment>
            <ActionTooltip title="Regresar al dashboard">
                <IconButton onClick={onSalir}>
                    <HomeIcon className="icon" /><p className="icon">Salir</p>
                </IconButton>
            </ActionTooltip>
            <ActionTooltip title="Buscar cliente">
                <IconButton onClick={onBuscarCliente}>
                    <SearchIcon className="icon" /><p className="icon">Buscar</p>
                </IconButton>
            </ActionTooltip>
            <ActionTooltip title="Recibir abono">
                <IconButton onClick={onNuevoAbono} disabled={disabledNuevoAbono}>
                    <AddIcon className="icon" /><p className="icon">Abono</p>
                </IconButton>
            </ActionTooltip>
            <ActionTooltip title="Vista previa del estado de cuenta">
                <IconButton onClick={onVistaPreviaEstado} disabled={disabledVistaPrevia}>
                    <VisibilityIcon className="icon" /><p className="icon">Vista previa</p>
                </IconButton>
            </ActionTooltip>
        </Fragment>
    );
}
